import { ArrowLeftOutlined } from '@ant-design/icons';
import { useDocumentTitle, useScrollTop } from 'hooks';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter, useHistory, Redirect } from 'react-router-dom';
import { addProduct } from 'redux/actions/productActions';
import { useTranslation } from 'react-i18next';
import { PRICING, ACCOUNT } from 'constants/routes';
import firebase from 'firebase/firebase';
import ProductForm from 'components/product/ProductForm';
import { getBrands, getPlans } from '../../../redux/actions/homeActions';

const AddProduct = () => {
  const { t } = useTranslation();
  const history = useHistory();
  useScrollTop();
  useDocumentTitle(`${t('titleAddProduct')} - Uilpi`);
  const isLoading = useSelector((state) => state.app.loading);
  const [loadingButton, setLoadingButton] = useState(false);
  const [isAuthorized, setAuthorized] = useState(true);
  const dispatch = useDispatch();

  const store = useSelector((state) => ({
    user: state.auth,
    profile: state.profile,
    plans: state.home.plans,
    brands: state.home.brands,
    products: state.ownProducts
  }));

  useEffect(() => {
    if (store.plans.length === 0) dispatch(getPlans());
    if (store.brands.length === 0) dispatch(getBrands());
  }, []);

  const onSubmit = async (product) => {
    if (loadingButton) return;
    setLoadingButton(true);
    if (store.profile.role === 'USER') dispatch(addProduct(product));
    else if (store.profile.role === 'COMPANY') {
      const planDetails = store.plans.filter(
        (el) => el.id === store.profile.plan.type
      )[0];
      if (
        planDetails &&
        product.imageCollection.length < planDetails.limitPhotos &&
        store.products.total < planDetails.limitProducts
      ) {
        setAuthorized(true);
        await firebase.addProductCompany(store.user.id, product);
        window.location.href = '/account';
      } else {
        setAuthorized(false);
      }
    }
    setLoadingButton(false);
  };

  if (
    store.profile?.role === 'COMPANY' &&
    (!store.profile?.plan ||
      store.profile?.plan.expiration < new Date().getTime())
  ) {
    return <Redirect to={PRICING} />;
  }

  return (
    <div className="product-form-container">
      {!isAuthorized && (
        <h5 className="text-center toast-error">
          {t('addCompanyProductErrorPlan')}
        </h5>
      )}
      <h2>{t('titleAddProduct')}</h2>
      <ProductForm
        brands={store.brands}
        isLoading={isLoading}
        loadingButton={loadingButton}
        onSubmit={onSubmit}
        isNew
        product={{
          name: '',
          price: 0,
          description: '',
          keywords: [],
          image: '',
          sold: false,
          featured: false,
          visible: true,
          imageCollection: [],
          category: {
            type: 'Bicicletta',
            sub1: 'Strada',
            sub2: 'Corsa',
            assisted: 'Non Assistita',
            year: new Date().getFullYear(),
            size: 'M',
            weight: 8,
            wheels: 20,
            brand: 'Non Specificata'
          },
          address: {
            country: 'Italia',
            municipality: 'Milano',
            province: 'Milano',
            region: 'Lombardia',
            npa: '1000'
          }
        }}
      />
      <br />
      <button
        className="button button-muted w-100-mobile"
        disabled={isLoading || loadingButton}
        onClick={() => history.push(ACCOUNT)}
        type="button"
      >
        <ArrowLeftOutlined />
        &nbsp; {t('backProfileButton')}
      </button>
    </div>
  );
};

export default withRouter(AddProduct);
